const schema = {
  type: 'string', default: ''
};

const init = function () {
  this.el.setAttribute('data-networked', this.data);
};

export default { schema, init, update: init };
